import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {Router, RouterModule} from "@angular/router";

@Component({
    selector: 'app-footerlazy',
    templateUrl: './footerlazy.component.html',
    styleUrl: './footerlazy.component.scss',
    standalone: true,
    imports: [CommonModule, RouterModule],
})
export class FooterlazyComponent implements OnInit {
  @Input() afterLogin: boolean = true;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateTo(path: string) {
    this.router.navigate([path])
  }

}
